{
  "APP_TITLE": "UDHS",
  "SERVER_URL": ""
}